import * as React from "react";
import type { SVGProps } from "react";
const SvgNewcomerIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    className="newcomer_icon_svg__icon"
    viewBox="0 0 1024 1024"
    {...props}
  >
    <path
      fill="currentColor"
      d="M48.853 321.579c-30.677 16.213-30.72 62.464-.042 78.506l406.528 213.462a118.187 118.187 0 0 0 106.197 2.09L883.072 462.72v131.413L853.589 624a22.827 22.827 0 0 0-.682 30.976l37.12 41.088a19.925 19.925 0 0 0 29.354.683l38.912-39.382a22.827 22.827 0 0 0 .683-30.976l-27.861-30.805.085-1.707V439.851l43.35-20.608c31.231-14.891 33.023-61.099 3.029-78.507l-403.2-233.643a118.272 118.272 0 0 0-115.2-2.261L48.853 321.579zm424.918 383.445L225.237 578.987V776.66a42.667 42.667 0 0 0 23.979 38.315L465.237 920.49a128 128 0 0 0 115.627-1.707l197.376-103.51a42.667 42.667 0 0 0 22.87-37.76V578.988L550.783 705.195a85.333 85.333 0 0 1-77.013-.128z"
    />
  </svg>
);
export default SvgNewcomerIcon;
